var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { buildRetryConfig } from './retryConfig';
import { TIER_TIMEOUT_MS } from './timeouts';
export function createHttpClient(params) {
    const { tier, timeout, retry } = params, axiosConfig = __rest(params, ["tier", "timeout", "retry"]);
    const instance = axios.create(Object.assign(Object.assign({}, axiosConfig), { timeout: timeout !== null && timeout !== void 0 ? timeout : TIER_TIMEOUT_MS[tier] }));
    if (retry !== false) {
        axiosRetry(instance, buildRetryConfig(retry !== null && retry !== void 0 ? retry : {}));
    }
    return instance;
}
